export const isLeftItem = (
  index: number,
  activeItem: number,
  numberOfItem: number,
) => (activeItem === 0 ? index === numberOfItem - 1 : index === activeItem - 1);

export const isRightItem = (
  index: number,
  activeItem: number,
  numberOfItem: number,
) => (activeItem === numberOfItem - 1 ? index === 0 : index === activeItem + 1);
